import { LOCAL_STORAGE_KEY_SESSION_KEY } from 'common/constants/constants'

export default (sessionKey: string) => localStorage.setItem(LOCAL_STORAGE_KEY_SESSION_KEY, sessionKey)
